const c = [], i = [];
function u(t) {
  c.push(t);
}
function p(t) {
  i.push(t);
}
async function a(t, e) {
  if (c.length === 0)
    return [t, e];
  let r = t, n = e;
  for (const o of c) {
    const s = await o(r, n);
    s && (r = s.url, n = s.init ?? n);
  }
  return [r, n];
}
async function f(t) {
  if (i.length === 0)
    return t;
  let e = t;
  for (const r of i)
    e = await r(e);
  return e;
}
async function l(t, e, r) {
  console.log("Error in realFetch", t);
  const n = t;
  if (typeof n.json != "function") {
    e(t);
    return;
  }
  try {
    const o = await n.json();
    if (n.status === 401 && r?.getCurrentUser() && (o.errors?.[0]?.message === "Token is expired" || o.errors?.[0]?.message === "Invalid email or password")) {
      e(o), r.logout();
      return;
    }
    e(o);
  } catch {
    e(t);
  }
}
export {
  a as applyRequestInterceptors,
  f as applyResponseInterceptors,
  l as processFetchError,
  u as registerRequestInterceptor,
  p as registerResponseInterceptor,
  c as requestInterceptors,
  i as responseInterceptors
};
